import z from "zod";

const addressSuggestionSchema = z
  .object({
    placePrediction: z.object({
      place: z.string(),
      placeId: z.string(),
      text: z.object({
        text: z.string(),
        matches: z.array(
          z.object({
            endOffset: z.number(),
          }),
        ),
      }),
    }),
  })
  .transform((addressSuggestion) => ({
    ...addressSuggestion,
    id: addressSuggestion.placePrediction.placeId,
  }));

type AddressSuggestion = z.infer<typeof addressSuggestionSchema>;

export { addressSuggestionSchema, type AddressSuggestion };
